// extracted by mini-css-extract-plugin
export default {"root":"Background_root__81vwe","image":"Background_image__4RPow"};